import React from 'react';
import { ContentfulCoupon } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from './AssetTransformer';
import { CouponContent } from '../../types';
import { RichText } from '../../RichText';
import { getFriendlyFormattedDate } from '@jbhi-fi/utils/src/date/getFriendlyFormattedDate';

export abstract class CouponContentTransformer {
  static toCouponContent = (
    displayName: string,
    entry: ContentfulCoupon,
    expiryDate: string
  ): CouponContent | undefined => {
    if (!entry?.fields) return undefined;
    if (!entry.fields?.contentOne) return undefined;

    return {
      displayName,
      termsLabel: entry.fields?.headingOne,
      actionsLabel: entry.fields?.headingTwo,
      barcodeLabel: entry.fields?.headingThree,
      termsAndConditions: <RichText document={entry.fields?.contentOne} />,
      redemptionInstructions: entry.fields?.contentTwo ? <RichText document={entry.fields?.contentTwo} /> : undefined,
      image: AssetTransformer.toImageProps(entry.fields?.heroImage),
      additonalInstructions: entry.fields?.contentThree ? (
        <RichText document={entry.fields?.contentThree} />
      ) : undefined,
      expiryDateFormatted: getFriendlyFormattedDate(expiryDate, 'extraLong', true),
    };
  };
}
